// Module
var code = "<router-outlet></router-outlet> ";
// Exports
export default code;